import { get } from "lodash";
import format from "string-template";
import * as yup from "yup";

const validation = (messages, includedChildren = []) => {
  const schemaShape = {};
  includedChildren.forEach(({ userId, age, identity }) => {
    if (age >= 16) {
      schemaShape[`healthInsuranceRightsCertificate_${userId}`] = yup
        .array()
        .of(
          yup.object().shape({
            name: yup.string().required(messages.REQUIRED),
          }),
        )
        .required(
          format(messages.REQUIRED_CHILD_ATTACHMENT, {
            firstName: get(identity, "user.firstname"),
            lastName: get(identity, "user.lastname"),
          }),
        )
        .min(
          1,
          format(messages.REQUIRED_CHILD_ATTACHMENT, {
            firstName: get(identity, "user.firstname"),
            lastName: get(identity, "user.lastname"),
          }),
        )
        .max(1, messages.ONE_FILE);
    }
    if (age >= 18) {
      schemaShape[`dependentProof_${userId}`] = yup
        .array()
        .of(
          yup.object().shape({
            name: yup.string().required(messages.REQUIRED),
          }),
        )
        .required(
          format(messages.REQUIRED_CHILD_ATTACHMENT, {
            firstName: get(identity, "user.firstname"),
            lastName: get(identity, "user.lastname"),
          }),
        )
        .min(
          1,
          format(messages.REQUIRED_CHILD_ATTACHMENT, {
            firstName: get(identity, "user.firstname"),
            lastName: get(identity, "user.lastname"),
          }),
        )
        .max(1, messages.ONE_FILE);
    }
  });

  return yup.object().shape(schemaShape);
};

export default validation;
